import { cx } from "cva";
import { type AnchorHTMLAttributes, Fragment } from "react";

import { Badge } from "../Badge";
import { applyIconColor, IconButtonLinkBaseProps, variants } from ".";
import styles from "./index.module.css";
export const IconButtonExternalLink = ({
  className,
  disabled,
  children,
  variant = "solid",
  color,
  number,
  size,
  text,
  title,
  shadow,
  href,
  target = "_blank",
  rel = "noopener noreferrer",
  onClick,
  ...props
}: IconButtonLinkBaseProps & AnchorHTMLAttributes<HTMLAnchorElement>) => {
  const badgeVariant = variant === "solid" ? "lighted" : "solid";
  const badgeColor = variant !== "solid" && color === "key" ? "primary" : undefined;

  const coloredIcon = applyIconColor({ icon: children, variant, color });

  return (
    <a
      href={href}
      className={cx(styles.button, className)}
      tabIndex={disabled ? -1 : undefined}
      title={title}
      aria-disabled={disabled}
      target={target}
      rel={rel}
      onClick={disabled ? (event) => event.preventDefault() : onClick}
      {...props}
    >
      <span className={variants({ variant, color, size, shadow })}>
        {coloredIcon}
        {!!number && (
          <Badge number={number} variant={badgeVariant} color={badgeColor} size="s" className={styles.badge} />
        )}
      </span>
      {!!text && (
        <p className={styles.text}>
          {text.split(/<br\s*\/?>/i).map((line, index) => (
            <Fragment key={index}>
              {line}
              <br />
            </Fragment>
          ))}
        </p>
      )}
      {/* アイコンのみのボタンでは title がアクセシブルネームの供給源のため sr-only にも含める */}
      <span className="sr-only">
        {title}
        (別ウィンドウで開きます)
      </span>
    </a>
  );
};
